import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';
import { DATA_SHARING_POPUP } from '../../constants/popup-types';
import * as actions from '../../redux/actions';

class getUserData extends baseRequest
{
    constructor(isShowPopups=true) {
        super();
        this.name     = 'GetUserData';
        this.dispatch = null;
        this.response = null;
        this.Config   = new AppConfig();
        this.isShowPopups = isShowPopups
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getUserData);
    }

    // Parse successful response
    onSuccess() {
        this.updateState();
    }

    // Dispatch actions to update redux state
    updateState() {
        const { data } = this.response;

        AnalyticsManager.updateUserProperties(data);

        this.dispatch(actions.setUserData(data));
        this.dispatch(actions.setUserRequestDone(true));

        //here on load opens data sharing popup
        if (data?.shouldRequestDataSharingConsent) {
            if(this.isShowPopups) {
                this.dispatch(actions.addPopup({
                    type: DATA_SHARING_POPUP,
                    rejectConsentOnDismiss: true,
                }));
            }
        }
    }
}

export default getUserData;
